import Button                   from "components/Button/button";
import {InputGeneral}           from "components/Field/field";
import { useRef, useState }     from "react";
import { useNavigate }          from "react-router-dom";
import MainStyle                from "components/UI/main.module.scss";
import BtnChangeTheme           from "components/Buttons/Theme/BtnTheme";
import BtnLoginAvatar           from "components/Buttons/Avatar/BtnLogin";
import { GetLabel,q3x_FunData } from "Utilities/utils";

let appLang = null;

const HomePage = () => {
  const navigate = useNavigate();
  const [orderCode, setOrderCode] = useState(null);

  function handleOrderRedirect(code) {
    if ((code != "") && (code != null)) {
      navigate(`s/${code}`);
    }
  }

  return (
    <> 
      <div className={MainStyle.row}>
        <div className={MainStyle.col_12}>
          <div className={MainStyle.text_end}>
            <BtnChangeTheme></BtnChangeTheme>
            <BtnLoginAvatar></BtnLoginAvatar>
          </div>
        </div>
      </div>

      <div className={MainStyle.py_5}/>

      <div className={MainStyle.row}>
        <div className={MainStyle.col_lg_3}/>
        <div className={MainStyle.col_lg_6}>
          <div className={MainStyle.mx_3}>
            <div className={[MainStyle.container,
                            MainStyle.rounded_4,
                            MainStyle.shadow,
                            MainStyle.border,
                            MainStyle.bg_card
                            ].join(" ")}>
                <div className={MainStyle.py_3}/>
                <div className={MainStyle.row}>
                  <div className={MainStyle.col_lg_12}>
                    <div className={[MainStyle.d_flex, MainStyle.pb_3, MainStyle.mx_3].join(" ")}>
                      <span className={[MainStyle.fs_5, MainStyle.text_body, MainStyle.mx_2, MainStyle.text_justify, MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 3)}
                      </span>                
                    </div>
                  </div>
                </div>                    
                <div className={MainStyle.py_3}/>
                <div className={MainStyle.row}>
                  <div className={MainStyle.col_lg_12}>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mx_4].join(" ")}>
                      <InputGeneral
                          value={orderCode} 
                          className={[MainStyle.fs_5, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                          onChange={(event) => setOrderCode(q3x_FunData(event.target.value))}
                          placeholder={GetLabel(appLang, 4)}
                          maxLength={6}
                      />
                    </div>
                  </div>
                </div>
                <div className={MainStyle.py_3}/>
                <div className={MainStyle.row}>
                  <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mx_4].join(" ")}>
                      <Button
                        style={{width: '100%'}}
                        value={orderCode}               
                        onClick={() => handleOrderRedirect(orderCode)} 
                        className={[MainStyle.btn_blue, 
                                    MainStyle.rounded_4, 
                                    MainStyle.border, 
                                    MainStyle.shadow, 
                                    MainStyle.fs_5,
                                    MainStyle.text_white,
                                    MainStyle.p_3
                                  ].join(" ")}>
                          <span className={[MainStyle.py_5, MainStyle.m_3].join(" ")}>{GetLabel(appLang, 5)}</span>
                      </Button>
                    </div>
                  </div>
                </div>
                <div className={MainStyle.py_3}/>
            </div>
          </div>
        </div>
        <div className={MainStyle.col_lg_3}/>
      </div>
    </>
  );
};

export default HomePage;
